export abstract class JsonTransform {

    public abstract toJson(): object;
}
